var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDexswap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1026,
    height: 1024,
    viewBox: "0 0 1026 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M994.955 828.976L806.961 344.142L779.967 318.035L748.634 300.009L694.164 287.578L646.443 310.576L618.967 344.142L806.961 828.976H994.955Z",
    fill: "#43D9BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M994.955 828.976L806.961 344.142L779.967 318.035L748.634 300.009L694.164 287.578L646.443 310.576L618.967 344.142L806.961 828.976H994.955Z",
    fill: "url(#paint0_linear_4_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.391 420.534L582.953 908.199L609.707 934.715L640.873 953.217L695.226 966.478L743.154 944.208L770.934 911.063L587.372 423.399L399.391 420.534Z",
    fill: "#43D9BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.391 420.534L582.953 908.199L609.707 934.715L640.873 953.217L695.226 966.478L743.154 944.208L770.934 911.063L587.372 423.399L399.391 420.534Z",
    fill: "url(#paint1_linear_4_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M814.314 911.724L1026 429.46L838.013 427.217C838.013 427.217 668.346 847.959 645.613 909.154C629.902 945.176 615.608 943.049 582.953 908.199C688.325 1050.88 727.861 1060.28 814.314 911.724Z",
    fill: "#43D9BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M575.583 344.142L368.308 829.597L556.302 828.976C556.302 828.976 722.122 405.678 744.296 344.141C759.678 307.882 773.991 309.792 806.961 344.142C700.295 203.074 660.676 194.275 575.583 344.142Z",
    fill: "#43D9BB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M626.647 593.96L438.653 109.125L411.659 83.019L380.327 64.9932L325.856 52.5615L278.135 75.5601L250.659 109.125L438.653 593.96H626.647Z",
    fill: "#43D9BB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M626.647 593.96L438.653 109.125L411.659 83.019L380.327 64.9932L325.856 52.5615L278.135 75.5601L250.659 109.125L438.653 593.96H626.647Z",
    fill: "url(#paint2_linear_4_3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.083 185.518L214.645 673.183L241.399 699.699L272.565 718.201L326.918 731.461L374.846 709.191L402.626 676.047L219.064 188.382L31.083 185.518Z",
    fill: "#43D9BB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.083 185.518L214.645 673.183L241.399 699.699L272.565 718.201L326.918 731.461L374.846 709.191L402.626 676.047L219.064 188.382L31.083 185.518Z",
    fill: "url(#paint3_linear_4_3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M446.006 676.708L657.692 194.444L469.705 192.201C469.705 192.201 300.038 612.943 277.305 674.137C261.594 710.16 247.3 708.032 214.645 673.182C320.018 815.866 359.553 825.267 446.006 676.708Z",
    fill: "#43D9BB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M207.276 109.125L0 594.581L187.994 593.959C187.994 593.959 353.815 170.662 375.988 109.125C391.37 72.866 405.683 74.7755 438.653 109.125C331.987 -31.9425 292.368 -40.7413 207.276 109.125Z",
    fill: "#43D9BB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_3",
    x1: 684.524,
    y1: 346.628,
    x2: 936.942,
    y2: 690.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53235,
    stopColor: "#1E0B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F052F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_3",
    x1: 705.404,
    y1: 907.578,
    x2: 456.802,
    y2: 559.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53235,
    stopColor: "#1E0B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F052F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_3",
    x1: 316.216,
    y1: 111.612,
    x2: 568.634,
    y2: 455.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53235,
    stopColor: "#1E0B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F052F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_3",
    x1: 337.097,
    y1: 672.562,
    x2: 88.4941,
    y2: 324.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53235,
    stopColor: "#1E0B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F052F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDexswap);
export default __webpack_public_path__ + "static/media/dexswap.93edb90f7a97dbc9a17ea57a9be7c0ca.svg";
export { ForwardRef as ReactComponent };